<template>
  <pl-dialog 
    size="dessassociate_sequence_roundtable" 
    title="Remove from Sequence" 
    @close="$emit('close')"
    :disableOutsideClick="true"
  >
    <div class="h-full w-full overflow-y-auto py-4">
      <div class="flex flex-col h-full">
        <div class="overflow-y-auto h-full px-5">
          <div>
            This action will be remove this RoundTable '<span class="font-semibold text-gray-700">{{ roundtable_name }}</span>' from the sequence. It will not delete the RoundTable, but this action cannot be undone.
          </div>
        </div>
        <div class="flex flex-col px-5 flex-grow h-full">
          <div class="flex flex-col w-full space-y-1.5 mb-2">
            <span>Please type in "confirm" to continue</span>
            <input 
              v-model="confirm_tag_delete" 
              @keyup.enter="handleRemoveFromSequence()"
              placeholder="Type 'confirm' to remove roundtable from sequence" 
              type="text" 
              class="py-2 px-3 w-full border border-solid border-gray-200 bg-white rounded-md focus-within:border-red-500"
            />
          </div>
          <div class="flex items-center space-x-2">
            <button @click="$emit('close')" class="bg-gray-100 py-2 flex items-center justify-center space-x-2 text-blueGray-500 font-medium w-full rounded-md border border-solid border-gray-200">
              <span>Cancel</span>
            </button>
            <button @click="handleRemoveFromSequence()" class="bg-red-500 py-2 flex items-center justify-center space-x-2 text-red-50 font-semibold w-full rounded-md border border-solid border-red-500">
              <span>Confirm</span>
              <div v-if="is_removed_started === true" class="loader"></div>
            </button>
          </div>
          
        </div>
      </div>
    </div>
  </pl-dialog>
</template>
<script>
  import Vue from 'vue';
import { EventBus } from '../../../../../utils/event-bus';
  export default Vue.extend({
    props: {
      roundtable_name: String,
      sequence_name: String,
    },
    data: () => ({
      is_able_to_delete: false,
      confirm_tag: '',
      is_removed_started: false,
    }),
    computed: {
      confirm_tag_delete: {
        get: function() {
          return this.confirm_tag;
        },
        set: function(newValue) {
          this.confirm_tag = newValue;
          if (this.confirm_tag === 'confirm') {
            this.is_able_to_delete = true;
            return;
          }
          this.is_able_to_delete = false;
          return;
        }
      }
    },
    methods: {
      handleRemoveFromSequence: async function() {
        this.is_removed_started = true;
        if (this.confirm_tag !== 'confirm') {
          const toast = {
            type: "Error",
            message: "Please type in 'confirm' to continue!",
            time: 5000
          };
          EventBus.$emit("createToast", toast);
          return;
        }
        if (this.is_able_to_delete === true) {
          this.$emit('confirm_remove_sequence');
          return;
        }
        return;
      }
    },
    mounted: async function () {

    },
  });
</script>
<style scoped>
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 16px;
    height: 16px;
    margin-left: 12px;
    margin-top: 1px;
  }
  .loader {
    border-top: 3px solid rgba(255, 255, 255, 0.2);
    border-right: 3px solid rgba(255, 255, 255, 0.2);
    border-bottom: 3px solid rgba(255, 255, 255, 0.2);
    border-left: 3px solid #ffffff;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// RoundTableDessassociateModal.vue?aa285cc6